import { createAction } from 'redux-actions';

import { FETCH_PAGINATED_CUSTOMERS } from '~/actions/names';
import { createFulfilledToolkitAction } from '~/actions/helpers';

export const setPaginatedCustomersData = createAction(
  'app/SET_PAGINATED_CUSTOMERS_DATA'
);

export const setPaginatedCustomersLoading = createAction(
  'customers/SET_PAGINATED_CUSTOMERS_LOADING'
);

export const fetchPaginatedCustomersSuccess = createFulfilledToolkitAction(
  FETCH_PAGINATED_CUSTOMERS
);
